<template>
  <div class="logs">
    <div class="logs-container">
      <div v-for="(item, index) in logList" :key="index" v-bind:class="index == 0 ? 'first item' : 'item'">
        <div class="datetime">{{ item.datetime }}
          <sup v-if="index == 0">NEW!</sup>
        </div>
        <div class="introduce">
          <ol>
            <li v-for="(content, index) in item.content" :key="index">{{ content }}；</li>
          </ol>
        </div>
      </div>
    </div>
    <div class="todo">
      <div class="todo-title">TO DO LIST</div>
      <ul class="todo-list">
        <li v-for="(item, index) in todoList" :key="index" :class="item.done ? 'done' : ''">{{ item.content }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyLogs",
  data() {
    return {
      logList: [
        {
          datetime: '2025.5.17',
          content: [
            '跑步数据解析工具现已支持下载Excel',
            '跑步数据解析工具现已支持生成图表',
            '由于数据量较大，跑步数据解析工具如使用手机访问将无法得到最佳视觉效果'
          ]
        },
        {
          datetime: '2025.1.3',
          content: [
            '新开发了跑步数据解析工具，可用于解析佳明、高驰、华米导出的.fit文件',
            '可用于在线查看表格或图表形式，还可对原始数据转换为excel后下载查看[稍后上线]',
            '解决了跑步数据对比工具无法导入博能.tcx文件的bug'
          ]
        },
        {
          datetime: '2024.12.17',
          content: [
            'GPS轨迹对比工具开始支持.fit、.gpx、.tcx三种文件格式',
            '无需刷新页面即可上传文件重新开始对比'
          ]
        },
        {
          datetime: '2024.12.13',
          content: [
            '给GPS轨迹对比工具新增比例尺功能',
            '新增卫星图以及其他一些实用功能',
            '解决跑步数据对比时TCX文件上传后无法对比的问题'
          ]
        },
        {
          datetime: '2024.12.12',
          content: [
            '优化界面，开始支持手机访问',
            '解决了GPS轨迹对比工具中无法自动定位当前位置的问题',
            'GPS轨迹对比工具页面初始化时，会自动定位到当前所在位置',
            '增加了获取浏览器定位权限的功能'
          ]
        },
        {
          datetime: '2024.12.11',
          content: [
            '新增GPS轨迹对比工具'
          ]
        },
        {
          datetime: '2024.12.10',
          content: [
            '新增使用指南页面',
            '新增TO DO LIST',
            '新增我的设备页面，介绍我正在使用或曾经使用的设备',
            '新增工具的介绍和使用方法',
          ]
        },
        {
          datetime: '2024.12.9',
          content: [
            '优化整体UI',
            '跑步数据对比工具新增对博能TCX文件的支持',
            '博能的TCX内容有限，目前仅支持对比心率和步频',
            '新增更新日志功能'
          ]
        },
        {
          datetime: '2024.12.1',
          content: [
            '跑步数据对比工具上线',
            '支持高驰、佳明、颂拓、华米等.fit文件的对比'
          ]
        }
      ],
      todoList: [
        {
          content: '开通微信公众号访问',
          done: false
        },
        {
          content: '考虑支持CSV的可能性',
          done: false
        },
        {
          content: '轨迹对比工具对.fit文件的支持',
          done: true
        },
        {
          content: '手机版开发和支持',
          done: true,
        },
        {
          content: '开发轨迹对比工具',
          done: true
        },
        {
          content: '使用指南页面开发',
          done: true
        },
        {
          content: 'To do list开发',
          done: true
        }
      ]
    }
  }
};
</script>
<style scoped lang="scss">
.logs {padding: 20px 0; width:100%; max-width:$main-width; margin:auto; display: flex; justify-content: space-between;}
.item {
  &.first {
    .datetime {color:$primary-color;
      &::before {background-color:$primary-color;}
    }
    .introduce {
      color:#444;
    }
  }
}
.datetime {line-height:40px; font-size:20px; color:#777; position:relative; padding-left:20px; z-index:2;
  sup {font-size:12px; color:red; margin-left:5px; font-style: italic; font-weight: bold;}
  &::before {
    content: '';
    display:block;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background-color: #999;
    margin-right: 10px;
    position:absolute;
    top:50%;
    left:0;
    transform: translateY(-50%);
  }
}
.introduce {color:#999; line-height:36px; position:relative; padding-left:70px; z-index:1;
  &::before {
    content: '';
    display:block;
    width:1px;
    height:calc(100% + 30px);
    position:absolute;
    top:50%;
    left:5px;
    transform: translateY(-50%);
    background-color:#ddd;
  }
}
.introduce ol {margin:0; padding:0;}
.todo-title {font-size:24px; color:$primary-color; margin-bottom:10px;}
.todo-list {padding-left:60px; line-height:36px;
  .done {text-decoration:line-through; color:#999;}
}
@media only screen and (max-width: 768px) {
  .logs {padding:15px; flex-wrap: wrap;}
  .datetime {font-size:18px;}
  .introduce {padding-left:50px; line-height:28px; font-size:14px;}
  .logs-container {margin-bottom:30px;}
  .todo-title {font-size:18px; margin-bottom:5px;}
  .todo-list {padding-left:50px; line-height:28px; font-size:14px;}
}
</style>
